import { logging, utils } from '@heimdall/core-common';
var logger = logging.instantiateLogger('heimdall:core:domain:organization:codec');
import { Organization } from './models';
export var OrganizationCodec = utils.CodecUtils.generateCodec(logger)(Organization)(Organization.is);